export default {
  default: {
    createdText: 'Created',
    imageAltText: 'Project Image',
    manageImage: 'Manage Image',
  },
}
